angular
    .module('empower.modules')
    .constant('uploadFileWording', {
        UPLOAD_SUCCESS: 'Thank you. The uploaded document will be sent to our staff for processing!',
        UPLOAD_FAILED: 'Unexpected errors occurred during uploading!',
        LARGE_FILE_ERRORS_TO_COMPARE: ['File is too large', 'Total file size exceeded'],
        LARGE_FILE_ERROR_TO_SHOW: 'Your total file size exceeds the 7MB limit, please reduce the size of your file(s) and try uploading again.',
        OTHER_ERROR_TO_SHOW: 'This file(s) cannot be added.\r\n',
        INVALID_FILE_TYPE: "Uploaded files are not valid. You can only upload pdf, doc, docx, xls, xlsx, csv or image files.",
		INVALID_FILE_TYPE_WITH_MESSAGE: "Please upload valid file types. We currently accept pdf, doc, docx, xls, xlsx, csv, image or message files."
    });